import * as StoreUtils from "../../utils/StoreUtils";
import {
	UPDATE_PAGES,
	UPDATE_PAGE,
	MAKE_PAGES_SNAPSHOT,
	RESTORE_FROM_PAGES_SNAPSHOT,
} from "../constants/ActionConstants";

export function updatePages(updates) {
	StoreUtils.getStore().dispatch(_updatePages(updates));
}

export function updatePage(id, updates) {
	StoreUtils.getStore().dispatch(_updatePage(Object.assign(updates, { id })));
}

export function makePagesSnapshot(item) {
	StoreUtils.getStore().dispatch(_makePagesSnapshot(item));
}

export function restoreFromPagesSnapshot(item) {
	StoreUtils.getStore().dispatch(_restoreFromPagesSnapshot(item));
}

function _updatePages(items) {
	return (dispatch: (action) => void) => {
		dispatch({ items, type: UPDATE_PAGES });
	};
}

function _updatePage(item) {
	return (dispatch: (action) => void) => {
		dispatch({ item, type: UPDATE_PAGE });
	};
}

function _makePagesSnapshot(item) {
	return (dispatch: (action) => void) => {
		dispatch({ item, type: MAKE_PAGES_SNAPSHOT });
	};
}

function _restoreFromPagesSnapshot(item) {
	return (dispatch: (action) => void) => {
		dispatch({ item, type: RESTORE_FROM_PAGES_SNAPSHOT });
	};
}
